export default "__VITE_ASSET__CMaZ4rbX__"